export { default } from './GooglePoliciesInfo';
